
(function ($) {
    $(document).ready(function () {


        $('.menu_menu').on('click', function () {
            $('.overlay').addClass('active')
            $('.hidden_menu').addClass('active')
            $('body').addClass('overflow-hidden')
        });

        $('.close, .overlay').on('click', function () {
            $('.overlay').removeClass('active')
            $('.hidden_menu').removeClass('active')
            $('body').removeClass('overflow-hidden')
        });

        let today = new Date();
        let year = today.getFullYear();
        if ($('.year').length > 0) {
            $('.year').text(year);
        }


    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {






const header = document.querySelector('header');

function handleScroll() {
	if (window.scrollY > 10) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
}

window.addEventListener('scroll', handleScroll);

window.addEventListener('load', () => {
	handleScroll();
});


 

  const navbar = document.querySelector(".navbar");
  const hiddenWrap = document.querySelector(".hidden_menu__wrap");
  const logo = navbar ? navbar.querySelector(".navbar-brand") : null;
  const mainMenu = document.querySelector(".menu-menu-1");
  const menuRight = document.querySelector(".menu_right");

  let isMobile = window.innerWidth < 992;

  function moveToMobile() {
    if (!hiddenWrap) return;

    if (mainMenu && !hiddenWrap.contains(mainMenu)) {
      hiddenWrap.appendChild(mainMenu);
    }

    if (menuRight && !hiddenWrap.contains(menuRight)) {
      hiddenWrap.appendChild(menuRight);
    }
  }

  function moveToDesktop() {
    if (!navbar || !logo) return;

    // Вставляємо головне меню після логотипа
    if (mainMenu) {
      if (!mainMenu.parentElement || mainMenu.parentElement !== navbar) {
        if (menuRight && menuRight.parentElement === navbar) {
          navbar.insertBefore(mainMenu, menuRight);
        } else {
          navbar.appendChild(mainMenu);
        }
      }
    }

    // Вставляємо праве меню в кінець navbar
    if (menuRight && menuRight.parentElement !== navbar) {
      navbar.appendChild(menuRight);
    }
  }

  function checkResize() {
    const nowMobile = window.innerWidth < 992;
    if (nowMobile !== isMobile) {
      isMobile = nowMobile;
      if (isMobile) {
        moveToMobile();
      } else {
        moveToDesktop();
      }
    }
  }

  // Початкова перевірка
  if (isMobile) {
    moveToMobile();
  } else {
    moveToDesktop();
  }

  // Debounce на ресайз
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkResize, 150);
  });


})





AOS.init({
    once: true,
    duration: 1000,
});